<div class="row">
    <div class="col-24">
        <jqxGrid [width]="850" [source]="dataAdapter" [columns]="columns" [sortable]="true" [columnsresize]="true" #gridReference 
                 [pageable]="true" [pagesizeoptions]="[20, 50, 100]" [pagesize]="50" [autoshowcolumnsmenubutton]="false"
                 [autoheight]="true" [selectionmode]="'multiplerowsextended'">
        </jqxGrid>
    </div>
</div>